import { render, staticRenderFns } from "./ChannelThree.vue?vue&type=template&id=ac141618&scoped=true"
import script from "./ChannelThree.vue?vue&type=script&lang=js"
export * from "./ChannelThree.vue?vue&type=script&lang=js"
import style0 from "./ChannelThree.vue?vue&type=style&index=0&id=ac141618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac141618",
  null
  
)

export default component.exports